'use client'

import { useEffect } from 'react'
import { initAppInsights } from '@/src/lib/appInsights'
import { initWebVitals } from '@/src/lib/webVitals'

export function AppInsightsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initAppInsights()
    initWebVitals()
  }, [])

  return <>{children}</>
}
